import { StateNode } from '@ansys-internal/awf-angular/store';
import { AWCTreeItem } from '@ansys-internal/awc-angular/tree';

export class SelectedItemState implements StateNode<AWCTreeItem | undefined> {
  key: string = 'selectedItem';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => AWCTreeItem | undefined = () => undefined;
}
